import { useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import { MetricStatsApiModel } from '../../models/metrics.model';
import { MonitoringChartTypes } from '../../models/monitoring.model';

// services
import API from '../../services/api';

const getMetricStats = async (
    statsType: MonitoringChartTypes,
    id?: number,
    fetchMetricCards?: boolean,
): Promise<MetricStatsApiModel> => {
    const { data } = await API.getMetricStats({
        stats_type: statsType,
        id,
        metric_cards: fetchMetricCards,
    });
    return data;
};

export default function useMetricStatsQuery(params: {
    statsType: MonitoringChartTypes;
    id?: number;
    fetchMetricCards?: boolean;
}) {
    const queryKey: (string | number)[] = ['metricStats', params.statsType];

    if (params.id) {
        queryKey.push(params.id);
    }
    return useQuery<MetricStatsApiModel, BaseError>({
        queryKey: queryKey,

        queryFn: () =>
            getMetricStats(
                params.statsType,
                params.id,
                params.fetchMetricCards,
            ),
    });
}
